import React, { useState } from 'react';

export default function IntroTab({ record, loading, error }) {
  const [viewImage, setViewImage] = useState(null);

  return (
    <div className="active pt-[50px] lg:pt-[60px]">
      {error && <div className="mb-4 text-red-600 text-sm">에러: {String(error)}</div>}
      <div>
        <h3 className="mb-4 text-[18px] font-bold leading-[100%]">Introduction</h3>

        <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px] whitespace-pre-wrap">
          {loading && '불러오는 중...'}
          {!loading && record?.introduction && (
            <>{record?.introduction}</>
          )}
          {!loading && !record?.introduction && (
            <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              소개글이 등록되어 있지 않습니다. 작성을 권유드립니다
            </div>
          )}
        </div>
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Educational History</h3>
        <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px] whitespace-pre-wrap">
          {loading && '불러오는 중...'}
          {!loading && !Array.isArray(record?.education) && record?.education && (
            <>{record.education}</>
          )}
          {!loading && (!record?.education) && (
            <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              학력 정보가 등록되어 있지 않습니다. 작성을 권유드립니다.
            </div>
          )}
        </div>
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Career</h3>
        <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px] whitespace-pre-wrap">
          {loading && '불러오는 중...'}
          {!loading && !Array.isArray(record?.career) && record?.career && (
            <>{record.career}</>
          )}
          {!loading && (!record?.career) && (
            <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              경력 정보가 등록되어 있지 않습니다. 작성을 권유드립니다.
            </div>
          )}
        </div>
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Additional Images</h3>

        {loading && <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px]">불러오는 중...</div>}

        {!loading && record?.images?.length > 0 && (
          <ul className="additional-img flex flex-wrap gap-3">
            {record.images.map((img, idx) => (
              <li
                key={idx}
                className="group w-[calc((100%-12px)/2)] aspect-square border border-[#E4E8F1] rounded-[12px] overflow-hidden cursor-pointer sm:w-[calc((100%-24px)/3)] xl:w-[calc((100%-36px)/4)] 2xl:w-[calc((100%-48px)/5)]"
                onClick={() => setViewImage(img)}
              >
                <img
                  src={img}
                  className="w-full h-full object-cover group-hover:scale-[1.1] transition duration-300"
                  alt={`additional ${idx + 1}`}
                />
              </li>
            ))}
          </ul>
        )}

        {!loading && (!record?.images || record.images.length === 0) && (
          <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
            등록된 대표 이미지가 없습니다.
          </div>
        )}

        {viewImage && (
          <>
            <div className="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-100" onClick={() => setViewImage(null)} aria-hidden="true" />

            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95%] max-w-[1200px] h-[90vh] max-h-[900px] flex flex-col px-[40px] pb-[40px] pt-[30px] bg-white rounded-[12px] z-[101] lg:px-[60px] lg:pb-[60px] shadow-xl">
              <button className="self-end w-[18px] mb-[10px] cursor-pointer lg:mb-[14px] shrink-0" onClick={() => setViewImage(null)} aria-label="닫기">
                <img src={`${rmVars.themeUrl}images/clear-icon-333.png`} alt="close" />
              </button>

              <div className="flex-1 min-h-0 overflow-auto flex items-center justify-center">
                <a href={viewImage} target="_blank" rel="noreferrer noopener" className="block w-full h-full flex items-center justify-center cursor-pointer">
                  <img src={viewImage} className="max-w-full max-h-full object-contain" alt="img" />
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
